import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, TrendingUpIcon, InfoIcon, LockIcon, TrophyIcon } from 'lucide-react';
import { CourseCard } from '../components/CourseCard';
import { CoursesHero } from '../components/CoursesHero';
import { coursesData } from '../data/coursesData';
import { useProgress } from '../hooks/useProgress';
import { useAuth } from '../contexts/AuthContext';
export function Courses() {
  const {
    getCourseProgress,
    calculatePoints
  } = useProgress();
  const {
    unlockedAll,
    isAuthenticated
  } = useAuth();
  // Calculate total points
  const pointsBreakdown = calculatePoints();
  return <div className="w-full min-h-screen bg-[#F1F1F1]" data-id="element-8132">
      <CoursesHero data-id="element-8133" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-8134">
        {/* Points Summary Card - NEW */}
        {isAuthenticated && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-12" data-id="element-8135">
            <div className="bg-gradient-to-br from-amber-500 via-orange-500 to-red-500 rounded-2xl p-6 shadow-xl border-2 border-amber-300 relative overflow-hidden" data-id="element-8136">
              {/* Decorative elements */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full blur-3xl" data-id="element-8137"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full blur-2xl" data-id="element-8138"></div>

              <div className="relative z-10 flex flex-col md:flex-row items-center justify-between" data-id="element-8139">
                <div className="flex items-center space-x-4 mb-4 md:mb-0" data-id="element-8140">
                  <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center" data-id="element-8141">
                    <TrophyIcon className="w-9 h-9 text-white" data-id="element-8142" />
                  </div>
                  <div data-id="element-8143">
                    <h3 className="text-2xl font-bold text-white mb-1" data-id="element-8144">
                      Punctaj Total: {pointsBreakdown.totalPoints} puncte
                    </h3>
                    <p className="text-white/80 text-sm" data-id="element-8145">
                      {pointsBreakdown.lessonPoints} (lecții) +{' '}
                      {pointsBreakdown.moduleBonus} (module) +{' '}
                      {pointsBreakdown.courseBonus} (training-uri)
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-3" data-id="element-8146">
                  <div className="text-center bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2 border border-white/30" data-id="element-8147">
                    <p className="text-xs text-white/80 mb-1" data-id="element-8148">Lecții</p>
                    <p className="text-xl font-bold text-white" data-id="element-8149">
                      {pointsBreakdown.lessonPoints}
                    </p>
                  </div>
                  <div className="text-center bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2 border border-white/30" data-id="element-8150">
                    <p className="text-xs text-white/80 mb-1" data-id="element-8151">Module</p>
                    <p className="text-xl font-bold text-white" data-id="element-8152">
                      {pointsBreakdown.moduleBonus}
                    </p>
                  </div>
                  <div className="text-center bg-white/20 backdrop-blur-sm rounded-xl px-4 py-2 border border-white/30" data-id="element-8153">
                    <p className="text-xs text-white/80 mb-1" data-id="element-8154">Training-uri</p>
                    <p className="text-xl font-bold text-white" data-id="element-8155">
                      {pointsBreakdown.courseBonus}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>}

        {/* Access Information Banner */}
        {!isAuthenticated && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-12" data-id="element-8156">
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-2xl p-6 shadow-md" data-id="element-8157">
              <div className="flex items-start space-x-4" data-id="element-8158">
                <div className="flex-shrink-0" data-id="element-8159">
                  <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center" data-id="element-8160">
                    <InfoIcon className="w-6 h-6 text-white" data-id="element-8161" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-8162">
                  <h3 className="text-xl font-bold text-[#132C53] mb-3" data-id="element-8163">
                    📚 Informații despre accesul la training-uri
                  </h3>
                  <div className="space-y-3 text-gray-700" data-id="element-8164">
                    <div className="flex items-start space-x-2" data-id="element-8165">
                      <LockIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-8166" />
                      <p className="text-sm" data-id="element-8167">
                        <strong data-id="element-8168">Fără logare:</strong> Niciun training nu este
                        disponibil pentru vizualizare. Trebuie să te loghezi
                        pentru a accesa conținutul.
                      </p>
                    </div>
                    <div className="flex items-start space-x-2" data-id="element-8169">
                      <LockIcon className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-8170" />
                      <p className="text-sm" data-id="element-8171">
                        <strong data-id="element-8172">După logare:</strong> Doar primele 2
                        training-uri (Training 1 și Training 2) sunt disponibile
                        imediat.
                      </p>
                    </div>
                    <div className="flex items-start space-x-2" data-id="element-8173">
                      <LockIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-8174" />
                      <p className="text-sm" data-id="element-8175">
                        <strong data-id="element-8176">Training-uri 3-10:</strong> Se deblochează
                        automat după finalizarea procesului de onboarding și a
                        primelor training-uri.
                      </p>
                    </div>
                  </div>
                  <div className="mt-4 pt-4 border-t border-blue-200" data-id="element-8177">
                    <Link to="/auth/login" className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#357BEB] to-[#2868d8] text-white px-6 py-3 rounded-xl font-bold hover:shadow-lg transition-all" data-id="element-8178">
                      <span data-id="element-8179">Loghează-te pentru acces</span>
                      <ArrowRightIcon className="w-5 h-5" data-id="element-8180" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>}

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-8181">
          <h2 className="text-3xl md:text-4xl font-bold text-[#132C53] mb-4" data-id="element-8182">
            Toate training-urile disponibile
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-8183">
            10 training-uri complete care te vor transforma dintr-un agent
            începător într-un consultant imobiliar de top
          </p>
        </motion.div>
        <div className="relative" data-id="element-8184">
          <div className="absolute left-8 top-0 bottom-0 w-1 bg-gradient-to-b from-[#357BEB] via-[#357BEB] to-gray-200 hidden md:block" data-id="element-8185"></div>
          <div className="space-y-8" data-id="element-8186">
            {coursesData.map((course, index) => {
            // Override status if unlockedAll is true
            const displayCourse = unlockedAll ? {
              ...course,
              status: 'active' as const
            } : course;
            // Calculate dynamic progress for active courses
            const calculatedProgress = displayCourse.status === 'active' ? getCourseProgress(displayCourse.id, displayCourse.lessonCount) : undefined;
            return <div key={course.id} className="relative" data-id="element-8187">
                  <div className="hidden md:flex absolute left-0 w-16 h-16 bg-gradient-to-br from-[#357BEB] to-[#132C53] rounded-full items-center justify-center text-white font-bold text-xl shadow-lg z-10" data-id="element-8188">
                    {index + 1}
                  </div>
                  <div className="md:ml-24" data-id="element-8189">
                    <CourseCard course={displayCourse} index={index} calculatedProgress={calculatedProgress} data-id="element-8190" />
                  </div>
                </div>;
          })}
          </div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mt-16" data-id="element-8191">
          <div className="bg-gradient-to-r from-[#357BEB] to-[#132C53] rounded-2xl p-1" data-id="element-8192">
            <div className="bg-white rounded-xl p-8 md:p-12 text-center" data-id="element-8193">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-[#357BEB] bg-opacity-10 rounded-full mb-6" data-id="element-8194">
                <TrendingUpIcon className="w-8 h-8 text-[#357BEB]" data-id="element-8195" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#132C53] mb-4" data-id="element-8196">
                Fiecare training te aduce mai aproape de performanță
              </h3>
              <p className="text-gray-600 text-lg mb-8 max-w-2xl mx-auto" data-id="element-8197">
                Începe cu Conceptul CLC, iar restul se vor deschide pe măsură ce
                progresezi în cariera ta.
              </p>
              <div className="space-y-4" data-id="element-8198">
                <Link to="/curs/concept-clc" className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#357BEB] to-[#2868d8] text-white px-8 py-4 rounded-xl font-bold text-lg hover:from-[#2868d8] hover:to-[#357BEB] transition-all transform hover:scale-105 shadow-lg hover:shadow-xl" data-id="element-8199">
                  <span data-id="element-8200">Începe Training 1</span>
                  <motion.div animate={{
                  x: [0, 3, 0]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-8201">
                    <ArrowRightIcon className="w-5 h-5" data-id="element-8202" />
                  </motion.div>
                </Link>
                <p className="text-sm text-gray-500" data-id="element-8203">
                  Loghează-te pentru a continua training-urile avansate
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}